import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Chapter } from '@/module/Author/Chapter';
import { ChapterValidationAction } from '@/module/Author/Chapter/Validation/ChapterValidationAction';
import { ChapterCard } from '@/module/Author/Chapter/components/Card/ChapterCard';

interface CollapsableChapterProps {
  title: string;
  chapters: Chapter[];
}

export function CollapsableChapter({ title, chapters }: CollapsableChapterProps) {
  return (
    <CollapsableGroup
      title={title}
      items={chapters}
      renderValidation={chapter => (
        <ChapterValidationAction
          chapterId={chapter.id}
          variant="compact"
        />
      )}
      renderItem={chapter => (
        <ChapterCard
          chapter={chapter}
          onClick={() => window.open(`/author/chapter/${chapter.id}`)}
        />
      )}
    />
  );
}
